import React from 'react';

function Edit() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
      <path
        d="M6.74116 2.64554L5.35406 1.25884L5.90914 0.704153C6.15627 0.457017 6.72233 0.407982 7.0185 0.704153L7.29585 0.981495C7.59202 1.27767 7.54337 1.84372 7.29585 2.09125L6.74116 2.64554ZM6.18648 3.20062L2.30292 7.08418L0.5 7.5L0.915816 5.69708L4.79938 1.81352L6.18648 3.20062Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Edit;
